import React from 'react';
import {Helmet} from "react-helmet";

import HeaderContainer from 'containers/HeaderContainer';
import Footer from 'views/Footer';

import AppConstants from 'AppConstants';
import AppUtil from 'AppUtil';


const AppName = <b>{AppConstants.APP_NAME}</b>;
const SITE_URL = <b>{AppConstants.WEBSITE}</b>;


class HowMuchCanIMake extends React.Component {

	componentDidMount() {
		AppUtil.scrollToTop();
	}

	render() {
		return <div>
				<Helmet>
					<title>How much can I Make on Seto Canvas? | Seto Canvas</title>
				</Helmet>
				<HeaderContainer />

				<div style={{margin: '20px auto', padding: '0 10px'}} id="howMuchCanIInfo" className='scWidth'>
					<h2 style={{textAlign: 'center', margin: '20px 0'}}><u>How much can I Make on {AppName}?</u></h2>
					<p>Once you upload your design, our moderators will review your design and based on the number of colors used, the size of the design and various other factors, the price of the product will be determined. And, along with it the commission that you’ll earn per sales.</p>
					<p>An artist can expect to earn <b>at least Rs. 50</b> per sales. The amount will vary based on the price of the product. Higher the price of the product, higher will be your commission and vice-versa.
						Once you start generating sales, you can view your earned amount in your Dashboard and after the earned amount reaches <b>Rs. 2,000</b>, you can then request to withdraw it. </p>

					<h4 style={{textAlign: 'center'}}><i><i className="fa fa-exclamation-circle" aria-hidden="true"></i> Tip: Try making on average 1 sale per day and you should be able to earn Rs.2,000 every month conveniently.</i></h4>
					<p>All these numbers <i>(the number of product sold, the number of pending orders, amount earned per quantity sold, total amount earned)</i>, will be made transparently visible to the Artist on {SITE_URL}.</p>
				</div>

				<Footer />
			</div>
	}
}


export default HowMuchCanIMake;


// WEBPACK FOOTER //
// ./src/pages/docs/HowMuchCanIMake.js